/* 🤖 this file was generated by svg-to-ts */
export const siriusCaretDownSmall: {
  name: 'caret_down_small';
  data: string;
} = {
  name: 'caret_down_small',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.186 9.501a.75.75 0 0 1 0 1.061L13.248 14.5a.75.75 0 0 1-1.06 0L8.25 10.562a.75.75 0 1 1 1.061-1.06l3.407 3.406L16.125 9.5a.75.75 0 0 1 1.061 0Z" fill="currentColor"/></svg>`
};
